import classnames from 'classnames';
import React from 'react';

/**
 * The stepper Result displays the selected results of the step.
 *
 */
const Result = ({ children }) => {
  const className = classnames(
    'stepper__step-result',
  );

  return (
    <div className={className}>{children}</div>
  );
};

export default Result;
